<template>
  <b-modal
    v-model="modalVisible"
    title="Histórico da Pré-Análise"
    centered
    hide-footer
    size="lg"
  >
    <b-table
      :items="history"
      :fields="fields"
      responsive
     :per-page="8"
      :current-page="currentPage"
      hover
      show-empty
      empty-text="Nenhum histórico encontrado"
    >

      <template #cell(created_at)="data">
        {{ formatDateTime(data.item.created_at) }}
      </template>

      <template #cell(action)="data">
        {{ data.item.action || '-' }}
      </template>
    </b-table>
    <b-pagination
        v-model="currentPage"
        :total-rows="history.length"
        :per-page="8"
        align="center"
        size="sm"
        class="my-2"
      />
  </b-modal>
</template>

<script>
import { DateTime } from 'luxon'
import {
  BModal,
  BButton,
  BTable,
  BPagination
} from 'bootstrap-vue'

export default {
  name: 'AnalysisHistoryModal',

  components: {
    BModal,
    BButton,
    BTable,
    BPagination

  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    history: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    modalVisible: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  data() {
    return {
      currentPage: 1,
      fields: [
        {
          key: 'created_at',
          label: 'Data'
        },
        {
          key: 'action',
          label: 'Ação'
        }
      ]
    }
  },

  methods: {
    formatDateTime(date) {
      if (!date) return '-'

      return DateTime
        .fromISO(date)
        .toFormat('dd/MM/yyyy HH:mm:ss')
    }
  }
}
</script>

<style scoped>
::v-deep .modal-title {
  font-weight: 600;
}

::v-deep .table th {
  white-space: nowrap;
}

::v-deep .table td {
  vertical-align: middle;
}
</style>